'use client';

import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { ErrorServiceUnavailable } from '@/components/common/Error';
import type { RepayDialogMarket } from '../toRepayDialogMarket';
import type { PositionManagerRepayDialogProps } from '../types';
import SectionErrorBoundary from '../../../SectionErrorBoundary';
import { ERROR_FALLBACK_HEIGHT } from '../constants';
import { PositionManagerRepayWithBalance } from './';
interface RepayContentProps extends PositionManagerRepayDialogProps {
  isQueryLoading: boolean;
  queryError?: Error | null;
  loanAsset?: InterfaceToken;
  collateralAsset?: InterfaceToken;
  market?: RepayDialogMarket;
}
const RepayContent = props => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorServiceUnavailable minHeight={ERROR_FALLBACK_HEIGHT} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.collateralAsset || $[2] !== props.isQueryLoading || $[3] !== props.loanAsset || $[4] !== props.market || $[5] !== props.marketId || $[6] !== props.queryError) {
    t1 = <SectionErrorBoundary fallback={t0}><PositionManagerRepayWithBalance marketId={props.marketId} isQueryLoading={props.isQueryLoading} queryError={props.queryError} loanAsset={props.loanAsset} collateralAsset={props.collateralAsset} market={props.market} /></SectionErrorBoundary>;
    $[1] = props.collateralAsset;
    $[2] = props.isQueryLoading;
    $[3] = props.loanAsset;
    $[4] = props.market;
    $[5] = props.marketId;
    $[6] = props.queryError;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export default RepayContent;